import { Component, OnInit } from "@angular/core";
import { ROUTE_DRIVER_JOB, ROUTE_DRIVER_JOB_SIGN_IN, ROUTE_DRIVER_JOB_SIGN_UP } from "../shared/routes";
import { Router } from "@angular/router";
import { CarrierDataService } from "src/app/shared/services/carrier-data.service";
import { PublicCarrier } from "src/app/shared/models/public-carrier";

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: false
})
export class LandingPageComponent implements OnInit {
  carrierCompanyId: string = null;
  publishableKey: string = null;
  carrierData: PublicCarrier = null;

  constructor(
    private readonly router: Router,
    private readonly carrierDataService: CarrierDataService
  ) { }

  ngOnInit(): void {
    this.carrierCompanyId = sessionStorage.getItem('carrierCompanyId');
    this.publishableKey = sessionStorage.getItem('publishableKey');

    if (this.carrierCompanyId && this.publishableKey) {
      this.loadCarrierData(this.carrierCompanyId);
    }
  }

  loadCarrierData(companyId: string): void {
    this.carrierDataService.getCarrierPublicById(companyId).subscribe({
      next: (response) => {
        this.carrierData = response;
      },
      error: (err) => {
        console.error('Error fetching carrier data', err);
      }
    });
  }

  onNavigateToSignIn() {
    this.router.navigate([`/${ROUTE_DRIVER_JOB}`, ROUTE_DRIVER_JOB_SIGN_IN]);
  }

  onNavigateToSignUp() {
    this.router.navigate([`/${ROUTE_DRIVER_JOB}`, ROUTE_DRIVER_JOB_SIGN_UP]);
  }
}
